import { render, staticRenderFns } from "./CodemirrorTwigModeBtn.vue?vue&type=template&id=b77f14b4"
import script from "./CodemirrorTwigModeBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./CodemirrorTwigModeBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports